import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import classnames from 'classnames'

import PinResetRequestPasswordForm from './pin-reset-request-password-form'
import PinResetForm from './pin-reset-form'
import Button from '../button'
import styles from './pin-reset-model.css'

/**
 * PinResetModel renders the reset pin model when user forgets their pin code.
 * It includes 3 views in order: enter password -> reset pin -> confirm pin reset.
 */
const PinResetModel = () => {
  const history = useHistory()
  const [isRequestDone, setIsRequestDone] = useState(false)
  const [isPinReset, setIsPinReset] = useState(false)

  const onPasswordRequestSuccess = () => {
    setIsRequestDone(true)
  }

  const onPinReset = () => {
    setIsPinReset(true)
  }

  const onResetSuccess = () => {
    history.goBack()
  }

  return (
    <div>
      {
        !isRequestDone && !isPinReset && (
          <div className={styles.wrapper}>
            <div className={styles.header}>
              <h1 className={styles.title}>Forgot PIN?</h1>
              <span className={styles.subHeader}>
                Enter the account password to reset your PIN.
              </span>
            </div>
            <PinResetRequestPasswordForm
              onRequestSuccess={onPasswordRequestSuccess}
            />
          </div>
        )
      }
      {
        !isPinReset && isRequestDone && (
          <div className={styles.wrapper}>
            <div className={styles.header}>
              <h1 className={styles.title}>Reset Your PIN</h1>
              <span className={styles.subHeader}>
                Please enter your new PIN below.
              </span>
            </div>
            <PinResetForm
              onPinReset={onPinReset}
            />
          </div>
        )
      }
      {
        isPinReset && isRequestDone && (
          <div className={styles.wrapper}>
            <div className={classnames(styles.header, styles.confirmHeader)}>
              <h1 className={styles.title}>PIN is Reset</h1>
            </div>
            <p className={styles.description}>
              Your PIN has been updated successfully.
            </p>
            <Button
              className={styles.button}
              text="OK"
              onClick={onResetSuccess}
            />
          </div>
        )
      }
    </div>
  )
}

export default PinResetModel
